export default __webpack_public_path__ + "static/media/upload-icon.497870f3.svg";